import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SharedLavorazioniModule } from '../../main-home/pages/lavorazioni/modules/shared-lavorazioni/shared-lavorazioni.module';
import { AuthenticationService } from '../../../services/authentication.service';
import { InViewportDirective } from '../../../directives/in-viewport.directive';
import { BackButtonComponent } from '../../../components/back-button/back-button.component';

@Component({
    selector: 'app-forgot-password',
    imports: [CommonModule,
        ReactiveFormsModule,
        SharedLavorazioniModule,
        InViewportDirective,
        BackButtonComponent],
    templateUrl: './forgot-password.component.html',
    styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {
  isSent: boolean = false;
  validEmail: boolean = true;
  private authenticationService: AuthenticationService = inject(AuthenticationService);

  recoverPswForm = new FormGroup({
    email: new FormControl('', Validators.required),
  })

  constructor(private router: Router) { }

  send() {
    //Send the request to the server
    const email_val = this.recoverPswForm.get('email')?.value;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (emailRegex.test(email_val!)) {
      this.validEmail = true;
      this.isSent = true;
      if (email_val) {
        this.authenticationService.forgotPasswordServer(email_val);
      }
    }
    else {
      this.validEmail = false;
    }
  }
  goLogin() {
    this.router.navigate(['login']);
  }
}
